import React, { useEffect, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { conversationsActions } from "../../../../store/one-query/conversationSlice";
import "./getConversation.css";
import {
  resetUserInteracted,
  setChat1Data,
  setChat2Data,
  setChat3Data,
  setChat4Data,
  setChat5Data,
  setChat6Data,
  setDisplayConAtBottom,
  setIsGenerateImage,
  setIsGlobalSearch,
  setNewConversation,
  setSelectedPersona,
  setShowNavMenu,
  toggleFullWidthMode,
} from "../../../../store/one-query/chatsSlice";
import DeleteModal from "./DeletePopup";
import useGetLastActiveModels, {
  useDeleteConversation,
  useUpdateConversation,
} from "../../../../store/Apis/ConversationApi";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { OverlayTrigger, Tooltip, TooltipProps } from "react-bootstrap";
import HistoryItemIcon from "../../../../Custom-imeges/HistoryItemIcon";
import OptionsIcon from "../../../../Custom-imeges/OptionsIcon";
import { getModelChatMessage } from "../../../../store/one-query/ChatModelSlice";
import useNavigateToMainPage from "../../../../NavigateToMainPage";
import { metaTags } from "../../../../Helper";
import SeoHelmet from "../../../../shared/SeoHelmet";
interface HistoryItemProps {
  id: string;
  name: string | undefined;
  date: string;
  category: string | undefined;
}
interface UpdateConversationInterface {
  id: string;
  name: string | undefined;
  personaId: string;
}

const HistoryItem: React.FC<HistoryItemProps> = ({
  id,
  name,
  date,
  category,
}) => {
  const location = useLocation();
  const darkMode = useAppSelector((state) => state.User.darkMode);
  const [updateConName, setUpdateConName] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [updatedName, setUpdatedName] = useState<string | undefined>("");
  const [showRenameOrDeleteMenu, setShowRenameOrDeleteMenu] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const inputRef = useRef<HTMLInputElement>(null);
  const dispatch = useAppDispatch();
  const allConversations = useAppSelector(
    (state) => state.Conversations.conversations
  );
  const updateConversation = useUpdateConversation();
  const deleteConversation = useDeleteConversation();
  const [conversationName, setConversationName] = useState<string>();
  const activeConversationId = useAppSelector(
    (state) => state.Conversations.activeConversationId
  );
  const { getLastActiveModels, loading } = useGetLastActiveModels();
  const [conNameAnimation, setConversationNameAnimation] = useState(true);
  const [showOptionsIcon, setShowOptionsIcon] = useState(false);
  const navigateToMainPage = useNavigateToMainPage();
  const navigate = useNavigate();
  const handleDelete = () => {
    deleteConversation(id);
    setShowDelete(!showDelete);
    navigateToMainPage();
  };

  const selectedPersona = allConversations.find(
    (con) => con?.id === activeConversationId
  )?.persona;

  function formatDate(dateStr: string): string {
    const date = new Date(dateStr);

    const options: Intl.DateTimeFormatOptions = {
      day: "2-digit",
      month: "short",
    };
    const formattedDate = date.toLocaleDateString("en-GB", options);
    return formattedDate;
  }

  const handleUpdate = () => {
    let data: UpdateConversationInterface;
    if (selectedPersona && name) {
      data = { id, name: updatedName, personaId: selectedPersona.id };
      updateConversation(data);
    }
    setUpdateConName(false);
  };

  const handleActiveConversation = (conId: string) => {
    if (conId === activeConversationId) return;
    dispatch(setDisplayConAtBottom(true));
    dispatch(setIsGenerateImage(false));
    dispatch(setIsGlobalSearch(false));
    dispatch(resetUserInteracted());
    dispatch(toggleFullWidthMode(""));
    dispatch(conversationsActions.setActiveConversation(conId));
    dispatch(conversationsActions.setIsConHistoryClicked(true));
    dispatch(setChat1Data({ id: "", version: "", name: "" }));
    dispatch(setChat2Data({ id: "", version: "", name: "" }));
    dispatch(setChat3Data({ id: "", version: "", name: "" }));
    dispatch(setChat4Data({ id: "", version: "", name: "" }));
    dispatch(setChat5Data({ id: "", version: "", name: "" }));
    dispatch(setChat6Data({ id: "", version: "", name: "" }));
    dispatch(getModelChatMessage([]));
    getLastActiveModels(conId);
    dispatch(setNewConversation(false));
    navigate(`/conversation/${conId}`);
    dispatch(
      setSelectedPersona({ id: "", title: "", description: "", objective: "" })
    );
    setConversationNameAnimation(false);
    dispatch(setShowNavMenu(false));
  };

  const toggleUpdateConversationName = () => {
    setShowRenameOrDeleteMenu(false);
    setUpdateConName(!updateConName);
    setShowRenameOrDeleteMenu;
    setUpdatedName(conversationName);
    setTimeout(() => {
      if (inputRef.current) {
        inputRef.current.focus();
        inputRef.current.select();
      }
    }, 0);
  };

  const handleDeleteItem = () => {
    setShowRenameOrDeleteMenu(false);
    setShowDelete(true);
  };

  useEffect(() => {
    if (name) setConversationName(name);
  }, [name]);

  const handleClickOutside = (event: MouseEvent) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target as Node)
    ) {
      setShowRenameOrDeleteMenu(false);
    }
  };

  useEffect(() => {
    if (showRenameOrDeleteMenu) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showRenameOrDeleteMenu]);

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter" && !event.shiftKey) {
      handleUpdate();
    }
  };

  const renderTooltip =
    (tooltipText: string | undefined) => (props: TooltipProps) => {
      return tooltipText !== "" ? (
        <Tooltip
          className="history-item-tooltip"
          id="dropdown-item-tooltip"
          {...props}
        >
          <span className="persona-item-overlay">{tooltipText}</span>
        </Tooltip>
      ) : (
        <div></div>
      );
    };
  const isConversationPage = location.pathname.includes("/conversation/");
  return (
    <div
      className={` position-relative d-flex align-items-center justify-content-between my-2 ${
        activeConversationId === id && !updateConName && "selectedConversation"
      }`}
    >
      {isConversationPage&&(
      <SeoHelmet title={name ?? "Conversation"} metaTags={metaTags} />
      )}
      <OverlayTrigger
        placement="right"
        delay={{ show: 250, hide: 300 }}
        overlay={renderTooltip(conversationName)}
      >
        <div
          id="question-container"
          className={`d-flex align-items-center w-100 `}
          onClick={() => !updateConName && handleActiveConversation(id)}
          onMouseEnter={() => setShowOptionsIcon(true)}
          onMouseLeave={() => setShowOptionsIcon(false)}
        >
          <div style={{ marginBottom: !updateConName ? "0px" : "0" }}></div>
          {updateConName ? (
            <div className="d-flex align-items-center">
              <input
                ref={inputRef}
                className="inputUpdateConName px-2 py-0 rounded-0"
                value={updatedName}
                onChange={(e) => setUpdatedName(e.target.value)}
                onKeyDown={handleKeyDown}
              />
              <div className="d-flex align-items-center">
                <img
                  className="cancelUpdateConName c-pointer"
                  onClick={handleUpdate}
                />
                <img
                  className="updateConName c-pointer"
                  onClick={() => setUpdateConName(false)}
                />
              </div>
            </div>
          ) : (
            <div className="d-flex align-items-center justify-content-center c-pointer w-100">
              <div className={`containerName`}>
                <div className="d-flex flex-row align-items-start w-100">
                  <HistoryItemIcon />
                    <p
                      className={`historyItemTitle mb-0 font-inter
                    ${
                      conNameAnimation &&
                      conversationName != "New chat" &&
                      "con-name-animation"
                    }`}
                    >
                      {conversationName?? "New chat"}
                    </p>
                </div>
                {showRenameOrDeleteMenu && (
                  <div className="renameOrDeleteMenu" ref={dropdownRef} onClick={(e) => e.stopPropagation()}>
                    <p className="mb-0" onClick={toggleUpdateConversationName}>
                      Rename
                    </p>
                    <p className="mb-0" onClick={handleDeleteItem}>
                      Delete
                    </p>
                  </div>
                )}
              </div>
              {updateConName ? (
                <div className="d-flex align-items-center mx-2">
                  <img
                    className="cancelUpdateConName mx-2 c-pointer"
                    onClick={handleUpdate}
                  />
                  <img
                    className="updateConName c-pointer"
                    onClick={() => setUpdateConName(false)}
                  />
                </div>
              ) : (
                showOptionsIcon && (
                  <div
                    className={`align-self-start c-pointer`}
                    onClick={(e) =>{
                      e.stopPropagation()
                      setShowRenameOrDeleteMenu(!showRenameOrDeleteMenu)}
                    }
                    style={{
                      position: "absolute",
                      right: "10px",
                      top: "50%",
                      transform: "translateY(-50%)",
                    }}
                  >
                    <OptionsIcon />
                  </div>
                )
              )}
            </div>
          )}
        </div>
      </OverlayTrigger>

      <DeleteModal
        show={showDelete}
        handleClose={() => setShowDelete(!showDelete)}
        method={handleDelete}
        name="Delete conversation"
        message="You will no longer see this conversation here"
        deleteStep={true}
      />
    </div>
  );
};

export default HistoryItem;
